<template>
    <div>
        <div>
            <div class="base-menu">
                <div class="wrap-menu pointer" data-toggle="modal" data-target="#menuModal">
                    <img src="/assets/images/menu.svg" alt="Menu">
                </div>
                <div class="wrap-brand-auth">
                    <router-link :to="{ name: 'home' }">
                        <img src="/assets/images/arkadia.svg" alt="Arkadia">
                    </router-link>
                </div>
                <div></div>
            </div>
        </div>
        <div class="row align-middle notification-row">
            <div class="col-6 text-left notification-logo">
                <img src="/assets/images/yoursay-dark.svg" alt="Yoursay">
            </div>
            <div class="col-6 text-right wrap-notification">
                <div class="notification-bell pointer" @click="handleShowModal">
                    <div v-if="total > 0">
                        <span class="notification-mark"></span>
                    </div>
                    <img src="/assets/images/alarm.svg" alt="Yoursay">
                </div>
                <div class="pointer" @click="logout">
                    <span>Logout</span>
                </div>
            </div>
        </div>

        <!-- Modal Menu -->
        <div class="modal fade modal-menu" id="menuModal" tabindex="-1" aria-labelledby="menuModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <ul class="menu-list">
                            <li>
                                <router-link :to="{ name: 'home' }" :class="btndisable"><i class="icon-menu icon-home"></i> Beranda</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'profile' }" :class="btndisable"><i class="icon-menu icon-user"></i> Data Diri</router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'redeem' }" :class="btndisable"><i class="icon-menu icon-redeem"></i> Redeem</router-link>
                            </li>
                            <!-- <li>
                                <router-link :to="{ name: 'voucher' }" :class="btndisable"><i class="icon-menu icon-voucher"></i> Voucher</router-link>
                            </li> -->
                            <li>
                                <router-link :to="{ name: 'history' }" :class="btndisable"><i class="icon-menu icon-riwayat"></i> Riwayat</router-link>
                            </li>
                            <!-- <li>
                                <router-link :to="{ name: 'insight' }" :class="btndisable"><i class="icon-menu icon-insight"></i> Insight</router-link>
                            </li> -->
                            <li>
                                <a target="_blank" href="https://bit.ly/GuidebookYoursay"><i class="icon-menu icon-guidebook"></i> Guidebook</a>
                            </li>

                          <!--   <li>
                                 <router-link :to="{ name: 'event' }" :class="btndisable"><i class="icon-menu icon-event"></i> Riwayat Event</router-link>
                            </li> -->

<!--                            <li>-->
<!--                                <router-link :to="{ name: 'reward' }"><i class="icon-menu icon-reward"></i> Reward</router-link>-->
<!--                            </li>-->
                            <li>
                                <a @click="subInfo = !subInfo" class="pointer"><i class="icon-menu icon-info"></i> Info</a>
                                <i class="icon-menu icon-arrow" v-bind:class="subInfo ? 'up' : 'down'"></i>
                                <ul class="menu-list-sub" id="sub-info" v-if="subInfo">
                                    <li>
                                        <router-link :class="btndisable" :to="{ name: 'about' }">Tentang</router-link>
                                    </li>
                                    <li><router-link :class="btndisable" :to="{ name: 'writing-guide' }">Panduan Menulis</router-link></li>
                                    <li><router-link :class="btndisable" :to="{ name: 'terms-article' }">Syarat & Ketentuan Article</router-link></li>
                                     <li><router-link :class="btndisable" :to="{ name: 'terms-video' }">Syarat & Ketentuan Video</router-link></li>
                                    <li><router-link :class="btndisable" :to="{ name: 'contact' }">Kontak</router-link></li>
                                </ul>
                            </li>
                            <li><a @click="subStatus = !subStatus" class="pointer"><i class="icon-menu icon-status"></i> Status Tulisan</a>
                                <i class="icon-menu icon-arrow" v-bind:class="subStatus ? 'up' : 'down'"></i>
                                <ul class="menu-list-sub" v-if="subStatus">
                                    <li><router-link :class="btndisable" :to="{ name: 'post-published' }">Published ({{ article.publish }})</router-link></li>
                                     <li><router-link :class="btndisable" :to="{ name: 'post-pending' }">Pending ({{ article.pending }})</router-link></li>
                                    <li><router-link :class="btndisable" :to="{ name: 'post-draft' }">Draft ({{ article.draft }})</router-link></li>
                                    <li><router-link :class="btndisable" :to="{ name: 'post-editing' }">Editing ({{ article.editing }})</router-link></li>
                                    <li><router-link :class="btndisable" :to="{ name: 'post-revision' }">Revision ({{ article.revision }})</router-link></li>
                                    <li><router-link :class="btndisable" :to="{ name: 'post-rejected' }">Rejected ({{ article.rejected }})</router-link></li>

                                </ul>
                            </li>
                            <li><a @click="subVideo = !subVideo" class="pointer"><i class="icon-menu icon-video"></i> Status Video</a>
                                <i class="icon-menu icon-arrow" v-bind:class="subVideo ? 'up' : 'down'"></i>
                                <ul class="menu-list-sub" v-if="subVideo">
                                    <li><router-link :class="btndisable" :to="{ name: 'video-published' }">Published ({{ video.publish }})</router-link></li>
                                     <li><router-link :class="btndisable" :to="{ name: 'video-pending' }">Pending ({{ video.pending }})</router-link></li>
                                    <li><router-link :class="btndisable" :to="{ name: 'video-draft' }">Draft ({{ video.draft }})</router-link></li>
                                     <li><router-link :class="btndisable" :to="{ name: 'video-editing' }">Editing ({{ video.editing }})</router-link></li>
                                    <li><router-link :class="btndisable" :to="{ name: 'video-rejected' }">Rejected ({{ video.rejected }})</router-link></li>
                                </ul>
                            </li>
                            <li>
                                <router-link :class="btndisable" :to="{ name: 'help' }"><i class="icon-menu icon-help"></i> Bantuan</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal Notification -->
        <div class="modal fade modal-notification" id="notificationModal" tabindex="-1" aria-labelledby="notificationModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="!loading">
                            <div v-if="point.length > 0">
                                <div v-for="item in point" v-bind:key="item._id">
                                    <riwayat-card :color="item.type === 'redeem_verif' ? 'green' : 'orange'" :read="false" :date="item.c_date" :text="item.ket"/>
                                    <hr/>
                                </div>
                                <div class="notification-more">
                                    <router-link :to="{ name: 'riwayat' }">Selengkapnya</router-link>
                                </div>
                            </div>
                            <div class="text-center" v-else>
                                <p>Tidak ada notification</p>
                            </div>
                        </div>
                        <div class="text-center" v-else>
                            <pulse-loader color="#EC550E"></pulse-loader>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
#menuModal {
    z-index: 9999999;
    padding-right: 0 !important;
}
.base-menu {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px rgb(0 0 0 / 15%);
    position: fixed;
    width: 100%;
    z-index: 99;
    justify-content: center;
}
.wrap-brand-auth {
    text-align: center;
    padding: 15px;
    background: #fff;
}
.wrap-brand-auth img {
    width: 170px;
    height: auto;
}
.wrap-menu {
    padding: 15px 20px;
    position: absolute;
    left: 0;
}
.wrap-notification {
    flex-direction: row;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.notification-bell {
    margin-right: 10px;
    position: relative;
}
.notification-bell img {
    width: 25px;
}
.notification-bell .notification-mark {
    width: 8px;
    height: 8px;
    background-color: red;
    display: block;
    border-radius: 50%;
    position: absolute;
    right: 3px;
}
.notification-row {
    margin-right: 0;
    margin-left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: flex-start;
    padding: 75px 15px 15px 15px;
}
.notification-logo img {
    width: 140px;
}

.modal-menu .modal-dialog {
    max-width: 100%;
    height: 100%;
    margin: 0;
}
.modal-menu .modal-header {
    border-bottom: none;
    width: 100%;
}

.modal-menu .modal-content {
    border-radius: 0;
    min-height: 100%;
    border: transparent;
}
.menu-list {
    list-style: none;
}
.menu-list li {
    padding: 12px 0;
}
.menu-list li a {
    color: #828282;
    flex-direction: row;
    display: flex;
    align-items: center;
    font-family: "Poppins", sans-serif;
}
.menu-list li a:hover {
    text-decoration: none;
}

.menu-list-sub {
    list-style: none;
    padding-inline-start: 30px;
}
.menu-list li .icon-arrow {
    margin-top: -12px;
    position: absolute;
    right: 78px;
}
.up {
    transform: rotate(
        180deg
    );
    margin-top: -30px !important;
    margin-right: 13px;
}
.down {
    transform: rotate(
        360deg
    );
}
.modal-notification .modal-header {
    border-bottom: none;
}
.modal-notification .modal-content {
    background: #E0E0E0;
    border: none;
}
.modal-notification.show .modal-dialog {
    transform: none;
    margin-top: 10%;
}
.modal-notification .modal-header {
    padding-right: 10px;
    padding-top: 5px;
}

.notification-more {
    text-align: center;
    padding-top: 10px;
}
.notification-more a {
    color: #828282;
}
.notification-more a:hover {
    text-decoration: none;
}
.menu-list .router-link-exact-active.router-link-active i {
    background-color: #333333;
}
.menu-list .router-link-exact-active.router-link-active {
    color: #333333 !important;
}
.modal-header .close {
    padding: 1rem 2rem;
    margin: -1rem -1rem -1rem auto;
}
@media only screen and (min-width: 768px) {
    .base-menu {
        width: 60%;
    }
    .modal-menu .modal-content {
        padding: 0 20%;
    }
}
</style>

<script>
import axios from "axios";
import $ from "jquery";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
    components: {
        PulseLoader
    },
    data() {
        return {
            loading: true,
            subInfo: false,
            subStatus: false,
            subVideo: false,
            point: [],
            total: 0,
            article: {},
            video: {},
            user:{},
            btndisable:'',
        }
    },
    mounted() {
        this.getPoint()
        this.getStatisticArticle()
        this.getStatisticVideo()
    },
    methods: {
        handleShowModal() {
            if(this.total > 0) {
                $('#notificationModal').modal('show');
                this.total = 0;
            } else {
                this.$router.push({name: 'history'});
            }
        },
        getUser() {


            const token = this.$cookies.get('token');
            axios.get('/api/user', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {

                    this.user = response.data
                    if(this.user.profile != "verif") {
                       this.btndisable = 'disabled';
                    }

                })
                .catch((error) => {

                });

        },
        getPoint(page = 1) {
            const token = this.$cookies.get('token');
            axios.get(`/api/activity?page=${page}&read`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.point = response.data.data
                    this.total = response.data.data.length
                    this.loading = false
                })
                .catch((error) => {

                });
        },
       async getStatisticArticle() {
            const token = this.$cookies.get('token');
            await axios.get('/api/user/statistic-article', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.article = response.data
                })
                .catch((error) => {

                });
        },
        async getStatisticVideo() {
            const token = this.$cookies.get('token');
            await axios.get('/api/user/statistic-video', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.video = response.data
                })
                .catch((error) => {

                });
        },
        async logout () {
            const token = this.$cookies.get('token');
            await axios.get('/api/logout', { headers: {"Authorization" : `Bearer ${token}`} })
            .then((response) => {
                // Handle login sso
                this.handleSso(response.data.url);
                //
                this.$notify({
                    duration: 5000,
                    group: 'main',
                    title: 'Berhasil!',
                    text: response.data.message,
                    type: 'success'
                });

                this.$cookies.remove('token');
                this.$cookies.remove('shared_token', null, '.arkadia.me');
                this.$router.replace({name: 'login'});
            })
            .catch((error) => {
                this.$cookies.remove('token');
                this.$cookies.remove('shared_token', null, '.arkadia.me');
                this.$router.replace({name: 'login'});
            });
        },
        handleSso(url) {
            url.forEach((item) => {
                $.getScript(item.url.toString())
                    .done(( script, textStatus ) => {
                        // totalRun = totalRun +1
                        // console.log(textStatus)
                    })
                    .fail(( jqxhr, settings, exception ) => {
                        // totalRun = totalRun +1
                    });
            });
        }
    }
}
</script>
